module.exports = __webpack_public_path__ + "static/screen-web-home-52204fb7a27b83971a2209f155ad4598.png";